<template>
    <div class="aboutus-container">
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('aboutUs.title')}}
                <hr>
            </span>
        </h1>
        <div class="row">
            <p>{{$t('aboutUs.introText.no1')}}</p><br/>
            <p>{{$t('aboutUs.introText.no2')}}</p>
            <p>
                <router-link to="/CoreCompetencies" v-if="$i18n.locale!='EN'">{{$t('aboutUs.here')}}</router-link>
                {{$t('aboutUs.introText.no3')}}
                <router-link to="/CoreCompetencies" v-if="$i18n.locale==='EN'">{{$t('aboutUs.here')}}</router-link>
            </p>
        </div>
        <div class="column-logo">
            <img src="../../assets/logo_white.png" alt="">
        </div>
        <!-- mptsolution
        <div class="row mptsolution-row">
            <div class="col-sm-4">
                <img class="logo" src="../../assets/images/MPT Solution_logo_blue.svg" alt="">
            </div>
            <div class="col-sm-4">
                <p>Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem qu.</p>
                <p>m semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc,</p>
            </div>
            <div class="col-sm-4">
                <img class="mptimg" src="../../assets/images/MPT.png" alt="">
            </div>
        </div> -->
        <!-- mptsolution list -->
        <div class="row mptlist-row">
            <div class="col-sm-4" v-for="(mptItem,index) in mptList[$i18n.locale]" :key="index">
                <img :src="mptItem.imgUrl" alt="">
                <h2>{{mptItem.title}}</h2>
                <p>{{mptItem.text}}</p>
            </div>
        </div>
        <!-- work us -->
        <div class="workus-row">
            <h1>{{$t('aboutUs.whyWorkWithUs')}}</h1>
            <ul class="worklist">
                <li v-for="(workItem,index) in workData[$i18n.locale]" :key="index">
                    <img :src="workItem.imgUrl" alt="">
                    <h2>{{workItem.title}}</h2>
                    <p>{{workItem.text}}</p>
                </li>
            </ul>
        </div>
        <!-- world -->
        <div class="row his-row">
            <!-- <img src="../../assets/images/World.png" alt=""> -->
            <h1>{{$t('aboutUs.history.title')}}</h1>
            <p>
                •&nbsp;&nbsp;&nbsp;&nbsp;{{$t('aboutUs.history.textNo1')}}
            </p>
            <p>
                •&nbsp;&nbsp;&nbsp;&nbsp;{{$t('aboutUs.history.textNo2')}}
            </p>
            <p>
                •&nbsp;&nbsp;&nbsp;&nbsp;{{$t('aboutUs.history.textNo3')}}
            </p>
            <!-- <div class="his-list">
                <div class="col-sm-5 his-bar his-bar-fir" >
                    <transition name="fade">
                        <div class="his-content" v-show="visiShow1">
                            <h2>Founded in 1999</h2>
                            <span class="his-year">1999</span>
                        </div>
                    </transition>
                    <span class="his-line" @mouseenter="visibleHistory(1)" @mouseleave="unvisibleHistory(1)"></span>
                </div>
                <div class="col-sm-2 his-bar his-bar-sec">
                    <transition name="fade">
                        <div class="his-content" v-show="visiShow2">
                            <h2>Merged with Getac Group</h2>
                            <span class="his-year">2007</span>
                        </div>
                    </transition>
                    <span class="his-line" @mouseenter="visibleHistory(2)" @mouseleave="unvisibleHistory(2)"></span>
                </div>
                <div class="col-sm-2 his-bar his-bar-thr">
                    <transition name="fade">
                        <div class="his-content" v-show="visiShow3">
                            <span class="his-year">2009</span>
                            <h2>Merged with Waffer Corp.</h2>
                        </div>
                    </transition>
                    <span class="his-line" @mouseenter="visibleHistory(3)" @mouseleave="unvisibleHistory(3)"></span>
                </div>
                <div class="col-sm-3 his-bar">
                    <span class="his-line"></span>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // visiShow1:false,
                // visiShow2:false,
                // visiShow3:false,
                mptList:{
                    EN:[
                        {
                            imgUrl:require('../../assets/images/pexels-bongkarn-thanyakij-3759089.png'),
                            title:'PURPOSE',
                            text:" We are committed to innovating the most advanced processes and materials to enrich people's lives." 
                        },{
                            imgUrl:require('../../assets/images/pexels-pixabay-373543.png'),
                            title:'VISION',
                            text:" With theoretical and practical experience in materials, processes and automation, we can meet various challenges and strive to become the industry's leading provider of mechanical component design and service."
                        },{
                            imgUrl:require('../../assets/images/283523-1-GEKBQ.png'),
                            title:'MISSION',
                            text:' Through joint-development with our partners, we provide mechanical parts and solutions that are extraordinary and sustainable to evolve with the industries. '
                        }
                    ],
                    CN:[
                        {
                            imgUrl:require('../../assets/images/pexels-bongkarn-thanyakij-3759089.png'),
                            title:'目的',
                            text:"我们致力于创新最先进的制程以及材质，使人们的生活丰富多彩。" 
                        },{
                            imgUrl:require('../../assets/images/pexels-pixabay-373543.png'),
                            title:'展望',
                            text:'我们在材质、制程和自动化方面拥有理论和实践经验，可以应对各种挑战，致力于成为业界领先的机构部件设计和服务提供商。'
                        },{
                            imgUrl:require('../../assets/images/283523-1-GEKBQ.png'),
                            title:'任務',
                            text:'我们通过与合作伙伴的联合开发，提供卓越的机构部件解决方案，以顺应产业趋势进行发展。'
                        }
                    ],
                    CHT:[
                        {
                            imgUrl:require('../../assets/images/pexels-bongkarn-thanyakij-3759089.png'),
                            title:'目的',
                            text:"我們致力於創新最先進的製程以及材質，使人們的生活豐富多彩。" 
                        },{
                            imgUrl:require('../../assets/images/pexels-pixabay-373543.png'),
                            title:'展望',
                            text:'我們在材質、制程和自動化方面擁有理論和實踐經驗，可以應對各種挑戰，致力於成為業界領先的機構部件設計和服務提供者。'
                        },{
                            imgUrl:require('../../assets/images/283523-1-GEKBQ.png'),
                            title:'任務',
                            text:'我們通過與合作夥伴的聯合開發，提供卓越的機構部件解決方案，以順應產業趨勢進行發展。'
                        }
                    ],
                    JP:[
                        {
                            imgUrl:require('../../assets/images/pexels-bongkarn-thanyakij-3759089.png'),
                            title:'目的',
                            text:"当社は、全ての人々の生活を豊かにする部品のための最先端制造プロセス及び材料に専念しております。" 
                        },{
                            imgUrl:require('../../assets/images/pexels-pixabay-373543.png'),
                            title:'ビジョン',
                            text:'材料、プロセス及び自动化分野における研究と生产経験を利用して、卓越したメカニカルデザイン及び制造サービス提供すると努力します。'
                        },{
                            imgUrl:require('../../assets/images/283523-1-GEKBQ.png'),
                            title:'使命',
                            text:'パートナーとの共同开発を通じて、业界を発展させるために卓越して、そして持続可能なメカニカル部品及び対策を提供します。'
                        }
                    ]
                },
                workData:{
                    EN:[
                        {
                            imgUrl:require('../../assets/images/guaranteed quality_icon.svg'),
                            title:'Guaranteed Quality',
                            text:'With our innovative manufacturing processes and comprehensive testing labs, we guarantee our clients impeccable products.'
                        },{
                            imgUrl:require('../../assets/images/increase global reach_icon.svg'),
                            title:'Increase Global Reach',
                            text:'Improve design and production efficiency through our global manufacturing facilities.'
                        },{
                            imgUrl:require('../../assets/images/long track record of success_icon.svg'),
                            title:'Long Track Record of Success',
                            text:'Since 1999, MPT Solution Corp. has been working with the world’s leading companies across industries, providing comprehensive mechanical design and manufacturing services.'
                        }
                    ],
                    CN:[
                        {
                            imgUrl:require('../../assets/images/guaranteed quality_icon.svg'),
                            title:'品质保证',
                            text:'我们通过创新的制程和完备的测试实验室，保证为客户们提供无可挑剔的产品。'
                        },{
                            imgUrl:require('../../assets/images/increase global reach_icon.svg'),
                            title:'提高全球占有率',
                            text:'通过我们的全球制造工厂，提升设计与生产效率。'
                        },{
                            imgUrl:require('../../assets/images/long track record of success_icon.svg'),
                            title:'长期的实绩',
                            text:'自 1999 年起，汉达精密与各产业的世界领先企业合作，提供全方位的机构部件设计和制造服务。'
                        }
                    ],
                    CHT:[
                        {
                            imgUrl:require('../../assets/images/guaranteed quality_icon.svg'),
                            title:'品質保證',
                            text:'我們通過創新的制程和完備的測試實驗室，保證為客戶們提供無可挑剔的產品。'
                        },{
                            imgUrl:require('../../assets/images/increase global reach_icon.svg'),
                            title:'提高全球佔有率',
                            text:'通過我們的全球製造工廠，提升設計與生產效率。'
                        },{
                            imgUrl:require('../../assets/images/long track record of success_icon.svg'),
                            title:'長期的實績',
                            text:'自 1999 年起，漢達精密與各產業的世界領先企業合作，提供全方位的機構部件設計和製造服務。'
                        }
                    ],
                    JP:[
                        {
                            imgUrl:require('../../assets/images/guaranteed quality_icon.svg'),
                            title:'品质安心',
                            text:'当社の革新的な制造プロセス及び完备な试験実験室により、お客様に安心いただける制品を保证します。'
                        },{
                            imgUrl:require('../../assets/images/increase global reach_icon.svg'),
                            title:'世界的活动能力の向上',
                            text:'当社の世界各地の制造工场を通じて、贵社のメカニカル部品の设计・生产速度を向上させます。'
                        },{
                            imgUrl:require('../../assets/images/long track record of success_icon.svg'),
                            title:'长期にわたる実绩',
                            text:'1999年以来、マイタックテクノロジー京都株式会社は、世界有数の企业と提携しており、広范囲にわたるメカニカルデザイン及び制造サービスを提供しています。'
                        }
                    ]
                }
            }
        },
        methods:{
            // visibleHistory(index){
            //     console.log(index)
            //     if(index==1){
            //         this.visiShow1 = true
            //     }
            //     if(index==2){
            //         this.visiShow2 = true
            //     }
            //     if(index==3){
            //         this.visiShow3 = true
            //     }
            // },
            // unvisibleHistory(index){
            //     if(index==1){
            //         this.visiShow1 = false
            //     }
            //     if(index==2){
            //         this.visiShow2 = false
            //     }
            //     if(index==3){
            //         this.visiShow3 = false
            //     }
            // }
        }
    }
</script>

<style scoped>
    .main-title hr{
        width:64% !important;
    }
    
    .column-logo{
        background:#00457A;
        padding:40px;
    }
    .column-logo img{
        max-width: 100%;
        height: auto;
        width: 12rem;
        display: block;
        margin:auto;
    }
    .mptsolution-row .logo{
        max-width: 100%;
        height:auto;
    }
    .mptsolution-row .col-sm-4{
        height:30rem;
        line-height: 30rem;
        overflow: hidden;
    }
    .mptsolution-row p{
        width:auto;
        text-align: left;
        line-height: 2rem;
        font-size: 1.6rem;
        margin-bottom: 2rem;
    }
    .mptlist-row img{
        max-width: 100%;
        height:auto;
    }
    .mptlist-row h2{
        font-size: 1.6rem;
        font-weight: 700;
        margin:2rem;
        color:#00457A;
    }
    .mptlist-row p{
        width: auto;
        font-size: 1.4rem;
        text-align: left;
        /* height:5.4rem; */
        line-height: 1.8rem;
        overflow: hidden;
    }
    .workus-row{
        width:100%;
        background: #29AAE1;
        overflow: hidden;
        padding: 4rem 0;
        margin-bottom: 2rem;
    }
    .workus-row h1{
        font-size: 3rem;
        font-weight: 700;
        color:#fff;
        margin-bottom: 6rem;
    }
    .worklist{
        max-width: 1200px;
        margin:1rem auto;
        overflow: hidden;
    }
    .worklist li{
        float:left;
        width: 33.333333%;
        padding:0 2rem;
    }
    .worklist li img{
        max-width: 100%;
        height:8rem;
    }
    .worklist li h2{
        font-size: 1.6rem;
        color:#fff;
        margin:2rem auto;
        font-weight: 700;
    }
    .worklist li p{
        color:#fff;
        font-size: 1.4rem;
        text-align: center;
        line-height: 1.5;
        overflow: hidden;
    }
    /* .his-row {
        max-width: 100%;
    } */
    .his-row h1{
        color:#003668;
        font-size: 3.5rem;
        font-weight: 700;
        margin-bottom: 10rem;
        margin-top: 6rem;
    }
    .his-row p{
        width:auto;
        text-align: left;
        margin-bottom: 2rem;
        padding-left: 2rem;
        padding-right: 2rem;
    }
    .his-list{
        margin-top: 2rem;
        margin-bottom: 12rem;
        padding:0 4rem;
        height:20rem;
    }
    .his-list .his-bar{
        height: 20rem;
        position: relative;
    }
    .his-list .his-bar .his-line{
        display: block;
        width: 90%;
        height: 3rem;
        background:#003668;
        position: absolute;
        left: 0;
        bottom: 0;
    }
    .his-list .his-bar .his-line:hover{
        background:#D74B00;
    }
    .his-list .his-bar:last-child .his-line:hover{
        background:#003668;
    }
    .his-list .his-bar .his-content{
        width: 90%;
        position: absolute;
        left: 0;
        bottom: 0;
    }
    .his-list .his-bar-thr .his-content{
        bottom: -15rem;
    }
    
    .his-list .his-bar .his-content h2{
        width:20rem;
        font-size: 1.5rem;
        color: #414141;
        font-weight: 700;
        text-align: center;
        margin-left: -2.5rem;
        margin-bottom: 2rem;
    }
    .his-list .his-bar-thr h2{
        margin-bottom: 0;
        margin-top: 2rem;
    }
    .his-list .his-bar-fir .his-content h2{
        text-align: left;
    }
    .his-list .his-bar .his-content .his-year{
        display: block;
        width: 6rem;
        height:12.7rem;
        line-height: 6rem;
        color:#fff;
        font-size: 1.5rem;
        font-weight: 700;
        background: url(../../assets/images/year_1.png) left  center no-repeat;
        background-size: 100% auto;
    }
    .his-list .his-bar-sec .his-content .his-year{
        margin:0 auto;
    }
    .his-list .his-bar-thr .his-content .his-year{
        margin:0 auto;
        background: url(../../assets/images/year_2.png) left  center no-repeat;
        background-size: 100% auto;
        line-height: 16rem;
        height: 11.4rem;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 2s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
    @media (max-width:767px){
        .column-logo img{
            width: 6rem;
        }
        .mptlist-row{
            margin-bottom: 0 !important;
        }
        .mptsolution-row .col-sm-4{
            height:auto;
            line-height: initial;
        }
        .mptsolution-row p{
            font-size: 0.8rem;
            margin-bottom: 1rem;
            line-height: 1.2rem;
        }
        .mptsolution-row img{
            max-width:100%;
            margin-bottom:1rem;
        }
        .mptlist-row h2{
            font-size: 0.8rem;
            margin:1rem;
        }
        .mptlist-row p{
            font-size: 0.7rem;
            height:auto;
            line-height: 1rem;
            margin-bottom: 1rem;
        }
        .workus-row{
            padding:1rem 0;
            margin-bottom: 0;
        }
        .workus-row h1{
            font-size: 1rem;
            margin-bottom: 1rem;
        }
        .worklist{
            margin-bottom: 0;
        }
        .worklist li{
            float:initial;
            width:100%;
            margin-bottom: 1rem;
            padding:0 1rem;
        }
        .worklist li img{
            float:left;
            width:2.5rem;
            height: auto;
            margin:0 1rem;
        }
        .worklist li h2{
            font-size: 0.8rem;
            text-align: left;
            margin: 0.5rem auto;
        }
        .worklist li p{
            font-size: 0.7rem;
            line-height: 1rem;
            text-align: left;
            height: auto;
        }
        .his-row h1{
            font-size: 1.2rem;
            margin-bottom: 1rem;
            margin-top: 0;
        }
        .his-row p{
            margin-bottom: 1rem;
        }
        .world-row{
            margin:2rem
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Company/AboutUs.vue